import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useContext } from 'react';
import { useHistory, useLocation } from "react-router-dom";
// * CSS
import './graphControl.css';



// * Helpers
import AuthContext from '../../context/Auth/AuthContext';

/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { BiArrowFromRight } from "react-icons/bi";
/**api connection */
import {AMS} from "../../services/api";
/**notifications */
import Notifications, { ERROR_NOTIFICATION } from '../../helpers/notifications';



import TreeViewGA from '../ReusableComponents/TreeViewGA/treeViewGA';
import GraphView from './graphView';

const GraphControl = () => {
    /**We use the useTranslation hook to update the text when the language changes */
    const { t } = useTranslation('common');

    /**The useHistory hook allow us to redirect to another route */
    const history = useHistory();

    //* To can acess the parameters sent via history.push
    const location = useLocation();

    //block tree when data is loading
    const [blockTree, setBlockTree] = useState(false);

    // * State used to save the selected Matrix (this in the Matrix Tree)
    const [selectedGraphNodeData, setSelectedGraphNodeData] = useState(null);

    const [graphDataTree, setGraphDataTree] = useState([]);

    // Session context to get the current institution data
    const { get_user_from_session } = useContext(AuthContext);


    /**Triggered when user clicks "Go Back" button. Redirects to Scenarios view*/
    const goToScenarios = () => {
        // location.state.detail has current scenario information:
        // Example:
        //
        //   {
        //       code: "BORREME01"
        //       description: "Borreme"
        //       editLockUserCode: null
        //       finalYear: 2025
        //       institutionId: 0
        //       isCalculated: false
        //       isLock: false
        //       modelId: 4
        //       modelName: "Example 29.09.2021"
        //       name: "BORREME 01"
        //       path: null
        //       scenarioId: 89
        //   }
        //
        // it may used to pass the information back:
        //
        // history.push({
        //     pathname: '/Dashboard',
        //     state: {
        //         detail: location.state.detail 
        //     }
        // });
        history.push('/Scenarios');
    }

    // we use useEffect to set the states
    useEffect(() => {
        // Calls the funtion that gets the tree data
        getTreeJson();
    }, []);

    const getTreeJson = async () => {
        try {
            //* call to API to get the tree json
            const response = await AMS.get(`/dashboardtree/SCENARIO/${location.state.detail.scenarioId}?usr=${get_user_from_session().user.email}`);
            //* Expand the selected node
            setGraphDataTree(response.data.data)
        } catch (error) {
            Notifications.notify(String(error), ERROR_NOTIFICATION);
            console.log(error)
        }
    }
    const handleGraphClick = (graphData) => {
        setBlockTree(true);
        //initial selectors
        let selectors = "";
        if (graphData.type === 'graph') {
            if (graphData.breadcrumb !== "") {
                const selectorsList = graphData.breadcrumb.split(',');
                const initialSelectors = selectorsList.map((item) => {
                    if(item === "sboth")
                        return `${item}=2`
                    else
                        return `${item}=0`
                });
                selectors = initialSelectors.join(',');
            }
        }
        // State variable with all selected node information
        setSelectedGraphNodeData({...graphData, initialSelectors:selectors});
    }

    return (
        <>
            <div>
                <div className="sub_menu">
                    <div className="sub_menu_btns my-1">
                        <button className="ilo-btn wizard_goBack_btn" onClick={goToScenarios}> <BiArrowFromRight /> {t('scenarios.goBack')}</button>
                    </div>
                </div>
                <div className="container-fluid mt-1">
                    <div className="row container_grid">
                        <div className="col-sm-12 col-md-2 col-lg-2 matrix_tree_container">
                            {/**Shows the tree with the list of graphs*/}
                            <TreeViewGA
                                dataSource={graphDataTree}
                                defaultOpen={location.state.code}
                                blockTree={blockTree}
                                afterClickLeaf={handleGraphClick}
                                searchingInTree={() => { handleGraphClick(null) }}
                            />
                        </div>
                        <div className="col-sm-12 col-md-10 col-lg-10">
                            {
                                /**Shows the spreadsheet control that will show the matrix data*/
                                selectedGraphNodeData === null ? <></> : <GraphView selectedNodeData={selectedGraphNodeData} setBlockTree={setBlockTree} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GraphControl